import { saveVariantSlicerGridFilterState as saveVariantSlicerGridFilterStateDiagram  } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';

export type Props = ApiMethodBase & {
    filterState: [];
};

export const saveVariantSlicerGridFilterState = ({
    filterState,
}: Props) => {
    saveVariantSlicerGridFilterStateDiagram(filterState);
};
